// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o8gO","textarea":"styles_textarea__12IFI"};